const CONFIGURATION = require('../../HostnameInformation.json');

function websocket(state = {
	ConnectionStatus: 'CLOSED',
	Hostname: CONFIGURATION?.Hostname ?? 'livetoair.net:4502'
}, action) {
	switch(action.type) {
	// Websocket Connection Status
	case 'WEBSOCKET_CONNECTION_PENDING': {
		return {...state, ConnectionStatus: 'PENDING'};
	}
	case 'WEBSOCKET_CONNECTION_FULFILLED': {
		return {...state, ConnectionStatus: 'CONNECTED'};
	}
	case 'WEBSOCKET_CONNECTION_REJECTED': {
		return {...state, ConnectionStatus: 'FAILED'};
	}
	case 'WEBSOCKET_CONNECTION_CLOSED': {
		return {...state, ConnectionStatus: 'CLOSED'};
	}
	default:
		return state;
	}
}

export default websocket;